import { forwardRef, useMemo } from 'react';
import WaveformInline from '../waveform/WaveformInline';
import MediaPlayer, {
  MediaPlayerHandle,
  MediaPlayerProps,
} from './MediaPlayer';
import { isVideoFile } from '../../utils/mediaFile';

/**************************************
 *  Types
 **************************************/
type IntelligentMediaPlayerProps = Omit<MediaPlayerProps, 'isVideo'> & {
  isDriveMounted?: boolean;
};

type IntelligentMediaPlayerHandle = MediaPlayerHandle;

/**************************************
 *  Component
 **************************************/
const IntelligentMediaPlayer = forwardRef<
  IntelligentMediaPlayerHandle,
  IntelligentMediaPlayerProps
>((props, ref) => {
  const { url, isDriveMounted = true } = props;

  // Determine if this is a video file
  const isVideo = useMemo(() => {
    return url ? isVideoFile(url) : false;
  }, [url]);

  // For video files, use the new MediaPlayer
  if (isVideo) {
    return <MediaPlayer {...props} isVideo={true} ref={ref} />;
  }

  // For audio files, use the existing WaveformInline
  // We need to convert MediaPlayer props to WaveformInline props
  const waveformProps = {
    url: props.url,
    loadUrl: props.loadUrl,
    height: props.height,
    changeTrack: props.changeTrack,
    autoplay: props.autoplay,
    redacted: props.redacted,
    isDriveMounted,
  };

  return <WaveformInline {...waveformProps} ref={ref} />;
});

IntelligentMediaPlayer.displayName = 'IntelligentMediaPlayer';

export default IntelligentMediaPlayer;
export type { IntelligentMediaPlayerHandle, IntelligentMediaPlayerProps };
